import {
  createMiniMap,
  createViewer,
  type MiniMapController,
  type MiniMapOptions,
  type ViewerController,
  type ViewerOptions,
} from "../index"

export interface ReactRuntimeFactories {
  createViewer(
    container: HTMLElement,
    options?: ViewerOptions,
  ): ViewerController
  createMiniMap(
    container: HTMLElement,
    viewer: ViewerController,
    options?: MiniMapOptions,
  ): MiniMapController
}

const defaults: ReactRuntimeFactories = { createViewer, createMiniMap }
let factories = defaults

export function getReactRuntimeFactories() {
  return factories
}

export function setReactRuntimeFactoriesForTest(
  replacement: ReactRuntimeFactories | null,
) {
  factories = replacement ?? defaults
}
